/* eslint-disable */
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Text,
  Collapse,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';
import { useAuth } from '../../../contexts/AuthContext';


export function SidebarLinks({ routes }) {
  const location = useLocation();

  const activeColor = useColorModeValue('gray.700', 'white');
  const inactiveColor = useColorModeValue(
    'secondaryGray.600',
    'secondaryGray.600',
  );
  const activeIcon = useColorModeValue('brand.500', 'white');
  const textColor = useColorModeValue('secondaryGray.500', 'white');
  const brandColor = useColorModeValue('brand.500', 'brand.400');

  const role = localStorage.getItem('role') || 'karyawan';

  const [openMenus, setOpenMenus] = React.useState({});

  const activeRoute = (routeName) =>
    location.pathname.includes(routeName);

  const toggleMenu = (name) => {
    setOpenMenus((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // 🔥 helper cek role
  const hasAccess = (route) => {
    if (!route.roles) return true;
    return route.roles.includes(role);
  };

  // 🔥 filter parent routes
  const filteredRoutes = routes.filter((route) => {
    if (route.hidden) return false;
    return hasAccess(route);
  });

  const createLinks = (routes) =>
    routes.map((route, index) => {
      // === 🔥 COLLAPSE MENU (PARENT) ===
      if (route.collapse && route.items) {
        // 🔥 filter child items
        const filteredItems = route.items.filter((item) => {
          if (item.hidden) return false;
          return hasAccess(item);
        });

        // ❗ kalau tidak ada child yg bisa diakses → hide parent
        if (filteredItems.length === 0) return null;

        return (
          <Box key={index}>
            <HStack
              onClick={() => toggleMenu(route.name)}
              cursor="pointer"
              py="10px"
              ps="10px"
            >
              <Flex w="100%" alignItems="center">
                <Box color={textColor} me="18px">
                  {route.icon}
                </Box>
                <Text color={activeColor} fontWeight="bold">
                  {route.name}
                </Text>
              </Flex>

              <Icon
                as={
                  openMenus[route.name]
                    ? MdKeyboardArrowDown
                    : MdKeyboardArrowRight
                }
                w="18px"
                h="18px"
                color={textColor}
              />
            </HStack>

            <Collapse in={openMenus[route.name]}>
              <Box ps="40px">
                {createLinks(filteredItems)}
              </Box>
            </Collapse>
          </Box>
        );
      }
// === 🔥 LOGOUT (SPECIAL CASE) ===
if (route.isLogout) {
  const { logout } = useAuth();
  return (
    <HStack
      key={index}
      onClick={() => {
        localStorage.clear();
        window.location.href = '/auth/sign-in';

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }}
      cursor="pointer"
      py="6px"
      ps="10px"
    >
      <Flex w="100%" alignItems="center">
        <Box me="18px">{route.icon}</Box>
        <Text color="red.400" fontWeight="bold">
          {route.name}
        </Text>
      </Flex>
    </HStack>
  );
}
      // === 🔥 NORMAL ROUTE ===
      
      if (['/admin', '/auth', '/rtl'].includes(route.layout)) {
        return (
          <NavLink key={index} to={route.layout + route.path}>
            <HStack
              spacing={activeRoute(route.path) ? '22px' : '26px'}
              py="6px"
              ps="10px"
            >
              <Flex w="100%" alignItems="center">
                <Box
                  color={
                    activeRoute(route.path)
                      ? activeIcon
                      : textColor
                  }
                  me="18px"
                >
                  {route.icon}
                </Box>

                <Text
                  me="auto"
                  color={
                    activeRoute(route.path)
                      ? activeColor
                      : textColor
                  }
                  fontWeight={
                    activeRoute(route.path)
                      ? 'bold'
                      : 'normal'
                  }
                >
                  {route.name}
                </Text>
              </Flex>

              <Box
                h="36px"
                w="4px"
                bg={
                  activeRoute(route.path)
                    ? brandColor
                    : 'transparent'
                }
                borderRadius="5px"
              />
            </HStack>
          </NavLink>
        );
      }

      return null;
    });

  return createLinks(filteredRoutes);
}

export default SidebarLinks;